export const environment = {
  production: false,
  baseUrl: "",
  baseHref: "/",
  isApp: true,
  domain: "https://budgetmanagerquality.calzedonia.com",
  keycloakUrl: "https://keycloak.dev.gcp.calzedonia.com",
  keycloakConfig: {
    realm: "bi-nocore-apps",
    clientId: "budget-manager-fe",
  },
  redirectUriApp: "capacitor://localhost",
  oktaRedirect:
    "https://budgetmanagerquality.calzedonia.com/auth/realms/quake/broker/samloktabm/endpoint",
  redirectUri: "https://budgetmanagerquality.calzedonia.com",
  name: "QA ENVIRONMENT",
  minName: "QA ENVIRONMENT",
  sentryName: "QA",
  deviceInfo: {
    appVersion: "",
    platform: "",
    uuid: "",
  },
  sentry: {
    tracesSampleRate: 0.5,
    captureConsole: ["error"],
    dns: "",
  },
};
